import { Layout as AntdLayout } from 'antd';

import 'antd/lib/layout/style/css';

const Layout = AntdLayout;

export default Layout;
